import React from 'react'
import PropTypes from 'prop-types'

// components
import { Confirmation, ConfirmationButton } from 'components/Confirmation'

import { TransitionGroup, MaxHeightTransition } from 'components/shared'

const AdminReportConfirm = props => {
  const { visible, onClickReport, onClickCancel } = props

  return (
    <TransitionGroup>
      {visible && (
        <MaxHeightTransition>
          <Confirmation
            visible
            header='Files reported as "inappropriate" will be immediately removed from all feeds viewable by staff, parents, and campers.'
            subheader='After reporting, contact your site director for next steps.'
          >
            <ConfirmationButton
              type='destructive'
              action={onClickReport}
              text='Report as inappropriate'
            />
            <ConfirmationButton action={onClickCancel} text='Cancel' />
          </Confirmation>
        </MaxHeightTransition>
      )}
    </TransitionGroup>
  )
}

AdminReportConfirm.propTypes = {
  visible: PropTypes.bool.isRequired,
  onClickReport: PropTypes.func.isRequired,
  onClickCancel: PropTypes.func.isRequired
}

export default AdminReportConfirm
